import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col } from 'react-bootstrap';
import BackToStoreButton from './BackToStoreButton';
import { BsBoxSeam, BsClipboardCheck } from 'react-icons/bs';
import { useTheme } from '../../context/PortalThemeContext';

const options = [
  {
    label: 'Start a Claim',
    description: 'Report an issue with a damaged, missing, or incorrect item.',
    icon: <BsClipboardCheck size={36} />,
    path: '/claims',
    color: 'var(--accent-color)',
  },
  {
    label: 'Start an Exchange or Return',
    description: 'Super easy and simple to use.',
    icon: <BsBoxSeam size={36} />,
    path: '/returns',
    color: 'var(--accent-color)',
  }
];

export default function SelectOption() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <div className="d-flex-column align-items-center justify-content-center" style={{ minHeight: '90vh', padding: '2rem' }}>
      <BackToStoreButton />
      <h2 style={{ color: 'white', fontWeight: 700, marginBottom: '2rem', textAlign: 'center', textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)' }}>
        What would you like to do?
      </h2>
      <Row className="w-100" style={{ maxWidth: '800px', gap: '2rem', justifyContent: 'center' }}>
        {options.map((option, index) => (
          <Col
            key={index}
            xs={12}
            md={5}
            className="d-flex"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(option.path)}
          >
            <Card
              className="option-card shadow-sm h-100 w-100"
              style={{
                border: '2px solid transparent',
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = option.color;
                e.currentTarget.style.transform = 'scale(1.02)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <Card.Body
                className="d-flex-column align-items-center text-center p-4"
                style={{
                  justifyContent: 'center',
                }}
              >
                <div style={{ color: option.color, marginBottom: '1rem' }}>
                  {option.icon}
                </div>
                <h4 style={{ fontWeight: 600 }}>{option.label}</h4>
                <p style={{ color: theme.textLight, fontSize: '0.95rem', marginTop: '0.5rem' }}>
                  {option.description}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
